<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="12">
          <b-form-group
              v-if="false"
              description="How long photo shall wait before transitioning?"
          >
            <label>Interval (sec):</label>
            <b-form-spinbutton
                id="match-size"
                v-model="settingsUser.interval"
                :min="intervalMin"
                :max="intervalMax"
                @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
              label="Optional Fields"
              description="The more fields filled in will provide a more comprehensive search and analysis. "
          >
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import noteColorsJSON from "../../assets/json/noteColors.json";


import ItemStore from "@/components/blockResources/_components/itemStore";
import ItemAddImage from "@/components/blockResources/_components/itemAddImage";
import ItemsSidebarSettings from "@/components/blockResources/_components/itemsSideBar";
import storeItemsAudioJSON from "../../assets/json/storeItemsSongs.json";
import DefaultPlayList from "@/components/blockResources/resourcePlayList/assets/json/defaultPlayList.json";
export default {
  name: "Settings_CallLog",
  components: {
    ItemStore,
    ItemAddImage,
    ItemsSidebarSettings
  },
  mixins: [ResourceBlockSettings],
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData"
    }),
    /* DATA */
    userDataPhotos() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].photos
        ? this.userData[`app_${this.resource.toolId}`].photos
        : DefaultPlayList;
    }
  },
  methods: {
    getListTools() {
      this.$store.dispatch("tools/getListTools").then(resources => {

      });
    },
    handleImageItems(photos) {
      let photoItems = {
        photos: photos
      };

      let notif = {
        //create message
        title: `${photos.length} Memories Added`,
        description: "Congrats you have updated your family playlist",
        variant: "success"
      };
      const payload = {
        userData: photoItems,
        notif: notif,
        key: "photos"
      };
      this.handleUpdateUserData(payload);
    },
    handleShowPlayListClick() {
      //inside of sidebar?
      this.sidebarModel = false;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    }
  },
  data() {
    return {
      settingsUser: {
        _hasEndDate:
          this.settings &&
          this.settings.user &&
          this.settings.user._hasEndDate !== undefined
            ? this.settings.user._hasEndDate
            : true,
        _hasTimeToTake:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasTimeToTake !== undefined
                ? this.settings.user._hasTimeToTake
                : true,
        _hasPrescriptionInfo:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasPrescriptionInfo !== undefined
                ? this.settings.user._hasPrescriptionInfo
                : true,
        _hasMedicationImage:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasMedicationImage !== undefined
                ? this.settings.user._hasMedicationImage
                : true,
        _hasNotes:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasNotes !== undefined
                ? this.settings.user._hasNotes
                : true,

        _hasRefillReminders:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasRefillReminders !== undefined
                ? this.settings.user._hasRefillReminders
                : true,
        _hasPharmacyInfo:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasPharmacyInfo !== undefined
                ? this.settings.user._hasPharmacyInfo
                : true,
        _hasDosageForm:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasDosageForm !== undefined
                ? this.settings.user._hasDosageForm
                : true,
        _hasNotification:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasNotification !== undefined
                ? this.settings.user._hasNotification
                : true,
        _hasPurpose:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasPurpose !== undefined
                ? this.settings.user._hasPurpose
                : true,
        _hasAllergies:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasAllergies !== undefined
                ? this.settings.user._hasAllergies
                : true,
        _hasStorageInstructions:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasStorageInstructions !== undefined
                ? this.settings.user._hasStorageInstructions
                : true,
        _hasSideEffects:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasSideEffects !== undefined
                ? this.settings.user._hasSideEffects
                : true,


        _hasEmergencyContact:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasEmergencyContact !== undefined
                ? this.settings.user._hasEmergencyContact
                : true,
        _hasTags:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasTags !== undefined
                ? this.settings.user._hasTags
                : true,
        _hasMedicationHistory:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasMedicationHistory !== undefined
                ? this.settings.user._hasMedicationHistory
                : true,
      },
      assetsURLHome: "",
      noteColorsJSON,
      storeItemsAudioJSON,
      sidebarId: "settings-sidebar",
      sidebarModel: false,
      modalImageAddId: "photoadd",
      intervalMin: 2,
      intervalMax: 100,
      toggles: [
        {
          name: "endDate",
          description: "For medications with a limited duration.",
          property: "_hasEndDate",
          type: "btns",
          text: "End Date",
          isAvail: true,
          value: true
        },
        {
          name: "timesToTake",
          description: "The specific times of the day when the medication should be taken (e.g., morning, lunch, evening)",
          property: "_hasTimeToTake",
          type: "btns",
          text: "Time to Take",
          isAvail: true,
          value: true
        },
        {
          name: "prescriptionInfo",
          description: "Including the prescribing doctor's name, clinic, and contact information.",
          property: "_hasPrescriptionInfo",
          type: "btns",
          text: "Prescription Information",
          isAvail: true,
          value: true
        },
        {
          name: "medicationImage",
          description: "Snap a photo of the medication or its packaging for easy visual identification.",
          property: "_hasMedicationImage",
          type: "btns",
          text: "Medication Image",
          isAvail: true,
          value: true
        },
        {
          name: "notes",
          description: "A space to add any additional notes or instructions related to the medication.",
          property: "_hasNotes",
          type: "btns",
          text: "Notes",
          isAvail: true,
          value: true
        },
        {
          name: "refillReminders",
          description: "Set reminders for when it's time to refill the prescription, ensuring a continuous supply.",
          property: "_hasRefillReminders",
          type: "btns",
          text: "Refill Reminders",
          isAvail: true,
          isPremium: true,
          value: true
        },
        {
          name: "pharmacyInformation",
          description: "Link the medication to a preferred pharmacy and store pharmacy details (name, location, contact info).",
          property: "_hasPharmacyInfo",
          type: "btns",
          text: "Pharmacy Information",
          isAvail: true,
          value: true
        },
        {
          name: "dosageForm",
          description: "Indicate whether the medication is a tablet, capsule, liquid, injection, etc.",
          property: "_hasDosageForm",
          type: "btns",
          text: "Dosage Form",
          isAvail: true,
          value: true
        },
        {
          name: "notifications",
          description: "Set up customizable medication reminders and notifications for dose times and refill reminders",
          property: "_hasNotification",
          type: "btns",
          text: "Notifications",
          isAvail: true,
          value: true,
          isPremium: false
        },
        {
          name: "purpose",
          description: "Categorize medications by type (e.g., pain relief, allergy, blood pressure) for better organization.",
          property: "_hasPurpose",
          type: "btns",
          text: "Purpose for Taking Medication",
          isAvail: true,
          value: true
        },
        {
          name: "allergies",
          description: "Input known allergies and potential drug interactions.",
          property: "_hasAllergies",
          type: "btns",
          text: "Allergies and Interactions",
          isAvail: true,
          value: true
        },
        {
          name: "storageInstructions",
          description: "Provide storage recommendations for the medication (e.g., store in a cool, dry place).",
          property: "_hasStorageInstructions",
          type: "btns",
          text: "Storage Instructions",
          isAvail: true,
          value: true
        },
        {
          name: "sideEffects",
          description: "Include a list of potential side effects associated with the medication.",
          property: "_hasSideEffects",
          type: "btns",
          text: "Side Effects",
          isAvail: true,
          value: true
        },
        {
          name: "emergencyContact",
          description: "Add an emergency contact for each or all medication-related issues",
          property: "_hasEmergencyContact",
          type: "btns",
          text: "Emergency Contact",
          isAvail: true,
          value: true
        },
        {
          name: "Tags",
          description: "Add custom labels or tags to further categorize and organize medications.",
          property: "_hasTags",
          type: "btns",
          text: "Tags",
          isAvail: true,
          value: true
        },
        {
          name: "medicationHistory",
          description: "Provide a record of medication history, including past prescriptions and usage.",
          property: "_hasMedicationHistory",
          type: "btns",
          text: "Medication History",
          isAvail: true,
          value: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
